(() => {
  const productHeader = document.querySelector(
    ".js-desktop-product-header .product-template__header"
  );
  const mobileReviewPosition = document.querySelector(".js-product-wrapper");
  const review = document.querySelector(
    "etrusted-product-review-list-widget-product-star-extension"
  );

  let mql = window.matchMedia("(min-width: 768px)");

  if (mql.matches) {
    productHeader.prepend(review);
  } else {
    mobileReviewPosition.prepend(review);
  }

  mql.onchange = (e) => {
    if (e.matches) {
      productHeader.prepend(review);
    } else {
      mobileReviewPosition.prepend(review);
    }
  };
})();
